module.exports = __webpack_public_path__ + "img/medical-charts-illustration.1728ab62.png";